import Color from 'color';

const white = '#FFFFFF';
const black = '#3e4d5c';

const bronze = '#21a4d2';

const grayText = '#858585';
const grayLight = '#E8E8E8';
const grayDisable = '#D5D5D5';
const grayDivider = '#C4C4C4';
const gray2 = '#525252';

const blue = '#0FA6C8';
const lightBlue = '#DAF8FF';
const blueBg = '#e5f1f6';
const grayBg = '#F5F5F5';
const blueMain = '#65c7f1';
const DarkBlue = '#1e2f42'
const MiddleBlue = '#e7f0f5'

const greenDark = '#2f80b3';
const greenMiddle = '#006B72';
const lightGreen = 'rgb(18, 70, 100)';
const softOrange = '#DEB65F';

const pink = '#FFDFDF';

const red = '#F2685F';
const redError = '#F44336';
const redErrorTransparent = Color(redError).alpha(0.23).string();

export default {
  black,
  white,

  bronze,

  grayText,
  blueBg,
  grayLight,
  grayDisable,
  grayDivider,
  gray2,
  grayBg,

  blue,
  lightBlue,
  blueMain,
  DarkBlue,
  MiddleBlue,

  greenDark,
  greenMiddle,
  lightGreen,

  softOrange,

  pink,

  red,
  redError,
  redErrorTransparent,
};
